import axios from "axios";

export const getProvincesListFromApi = () =>
  axios.get('provinces')
    .then(response => response.data)
    .catch(error => error);
